import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import React, { Component, lazy, Suspense } from 'react'
import { hot } from 'react-hot-loader'
import MoneyCover from 'components/moneyCover'

import './styles.scss'
import MoneyLeftOver from 'components/moneyLeftOver'
import MoneyCanvas from 'components/moneyCanvas'
import IncomeSlider from 'components/incomeSlider'
import { Waypoint } from 'react-waypoint'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dropdown.css'
import { Scrollama, Step } from 'react-scrollama'

declare global {
  // eslint-disable-next-line @typescript-eslint/interface-name-prefix
  interface Window {
    project: {
      version: string
      buildTimestamp: number
    }
    dataLayer: { event: string; event_action: string; event_label: string }[]
  }
}

const ARTICLE_ID = '205822301630'

const defaultPcts = {
  'Housing': 0.2104434214,
  'Taxes': 0.1004361522,
  'Health': 0.1235764478,
  'Food': 0.1510782651,
  'Transports': 0.09280348922,
  'Communications': 0.02326144899,
  'Clothing': 0.02495759632,
  'Hobbies': 0.06578628544,
  'Others': 0.1029803732
}

interface Expenses {
  value: number,
  spent: number,
  visible: boolean
}

interface SliderProps {
  element: any,
  data: number,
  direction: string,
}

interface Canvases {
  stage: number
}
// eslint-disable-next-line @typescript-eslint/interface-name-prefix
interface IState {
  showCover: boolean
  publishedTimestamp?: number
  income: number
  expenses: Expenses[]
  canvases: Canvases[]
}

class AppComponent extends Component<{}, IState> {
  public constructor(props: any) {
    super(props)

    this.state = {
      showCover: false,
      income: 7000,
      expenses: [
        {value: 0, spent: 0, visible: true},
        {value: 0, spent: 0, visible: false},
        {value: 0, spent: 0, visible: false},
        {value: 0, spent: 0, visible: false},
        {value: 0, spent: 0, visible: false},
        {value: 0, spent: 0, visible: false},
        {value: 0, spent: 0, visible: false},
        {value: 0, spent: 0, visible: false},
        {value: 0, spent: 0, visible: false}
      ],
      canvases: [
        {stage: 0},
        {stage: 0},
        {stage: 0},
        {stage: 0},
        {stage: 0}
      ]
    }
  }

  private calculateSpentAmount(id:number, value:number[]):void {
    console.log(value)
    let e = this.state.expenses
    e[id].value = value[2]
    e[id].spent = value[2] - value[1]
    this.setState({expenses: e})
  }

  public componentDidMount(): void {
    const domain = parseHostname()

    window
      .fetch(`https://m.${domain.publicationDomain}/api/articles/${ARTICLE_ID}`)
      .then(response => {
        if (response.ok) {
          return response.json()
        }
        throw new Error(`${response.status}: ${response.statusText}`)
      })
      .then(data => {
        this.setState({ publishedTimestamp: data.article.first_published_at })
      })
      .catch(e => {
        // tslint:disable-next-line
        console.groupCollapsed('Main')
        // tslint:disable-next-line
        console.warn('API Access failed: ', e)
        // tslint:disable-next-line
        console.groupEnd()
      })

    // this.inputBox.focus();
  }

  private validateSection(sectionId:number): void {
    if (sectionId < this.state.expenses.length - 1) {
      let e = this.state.expenses
      e[sectionId + 1].visible = true
      this.setState({expenses: e})
    }
  }

  private getIncomeSentence(income:number) {
    if(income < 6500) {
      return 'au dessous de la'
    } else if (income > 9500) {
      return 'au dessus de la'
    }else {
      return 'dans la'
    }
  }

  public render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead
          articleId={ARTICLE_ID}
        />

        {this.state.showCover && <MoneyCover zIndex={1}/>}

        <div className='ui vertical segment'>
          <div className='ui container'>
            <h1 className='ui header'>Combien dépensez-vous? Et les autres?</h1>
            <h2 className='ui header'>
              <div className='sub header'>
                Des dépenses vitales jusqu’aux loisirs
                et frais extraordinaires, que vous reste-t-il à la fin du mois? Estimez vos dépenses et
                comparez-vous à différents groupes démographiques.
              </div>
            </h2>
            <div className='ta author'>
              Mathieu Rudaz
            </div>
          </div>
        </div>
        <div className='ui text container widescreen hidden large screen hidden small'>
          <img style={{width:'100%', height:'auto', margin:'2em 0 2em 0'}} src={require('./cover.png')} />
        </div>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <p className='special'>
              Quel est le <b>revenu de votre ménage</b> après addition des revenus du travail, de
              la fortune et de la location, des rentes et transferts sociaux et des transferts reçus
              d’autres ménages?
            </p>
            <p className='special'>
              Le plus souvent, il s’agira simplement de votre <b>salaire net</b> ou de la somme de
              votre salaire net et de celui de votre conjoint-e, si vous vivez en couple.
            </p>
          </div>
        </div>
        <div className='ui text container userInput'>
          <p>Chaque mois, mon ménage gagne environ <b style={{color: "#ad427f", fontWeight: "600"}}>{this.state.income} <small style={{fontWeight: "400"}}> fr.</small></b></p>
        </div>
        <div className='ui container'>
          <IncomeSlider
            showGhost={true}
            income={20000}
            spent={1}
            default={7000}
            onSlideEnd={(value: number[]) => {
              this.setState({
                income: value[2] - 1
              })
            }}
          />
        </div>
        <div className='ui text container' style={{marginTop: '4em'}}>
          <p className='special'>
            C’est le revenu du travail qui est la composante principale du revenu des ménages, avec une
            part de 75,4%. Les rentes et transferts sociaux représentent, eux, en moyenne 19,1% du revenu brut.
          </p>       
        </div>

        <Waypoint
            onEnter={() => {console.log('WP #1: HIDE COVER'); this.setState({showCover: false})}}
        />

        <div className='scrollama-container'>
          <MoneyCanvas 
            stage={this.state.canvases[0].stage}
            initialSize={1}
            targetSizes={[]}
          />
          <div className='steps'>
            <Scrollama debug={false} onStepEnter={(args: SliderProps) => {
              console.log('Stage ' + args.data + ' - ' + args.direction)
              let canvases = this.state.canvases
              canvases[0].stage = args.data
              this.setState({canvases: canvases})
            }}>
              <Step data={1}>
                <div style={{height: '50vh'}} />
              </Step>
              <Step data={2}>
                <div style={{height: '50vh'}}>
                  <div className='ui container text message'>
                      <p className='special'>
                        Voici votre revenu. En gagnant{' '}
                        <b>{this.state.income} fr.</b>{' '}
                        par mois, vous vous situez {this.getIncomeSentence(this.state.income)} moyenne des revenus des ménages suisses.</p>
                  </div>
                </div>
              </Step>
              <Step data={2}>
                <div style={{height: '50vh'}} />
              </Step>
            </Scrollama>
          </div>
        </div>

        <div className='section'>
          <div className='ui text container'>
            <p className='special' >
              Les <b>impôts</b> représentent un des groupes de dépense les plus importants. Combien
              devez-vous à votre commune, votre canton et à la Confédération chaque mois?
            </p>
          </div>
          <MoneyLeftOver
            id={0}
            articleId={ARTICLE_ID}
            showGhost={true}
            title={'Impôts'}
            income={this.state.income}
            spent={1}
            default={this.state.income * defaultPcts['Taxes']}
            onChange={value => this.calculateSpentAmount(0, value)}
            onValidate={
              () => {
                this.validateSection(0)
              }
            }
          />
        </div>

        {this.state.expenses[1].visible && (<div className='section'>
          <div className='ui text container'>
            <p className='special' >
              Dans ce poste, tous les <b>frais de santé</b> sont pris en compte. Cela concerne toutes 
              les dépenses d’assurance de base ou
              complémentaire ainsi que les frais de santé non couverts par l’assurance.
            </p>
          </div>
          <MoneyLeftOver
            id={1}
            articleId={ARTICLE_ID}
            showGhost={true}
            title={'Santé'}
            income={this.state.income}
            spent={this.state.expenses[0].value}
            default={this.state.income * defaultPcts['Health']}
            onChange={value => this.calculateSpentAmount(1, value)}
            onValidate={
              () => {
                this.validateSection(1)
              }
            }
          />
        </div>)}

        {this.state.expenses[2].visible && (<div className='section'>
          <div className='ui text container'>
            <p className='special' >
              Le <b>loyer</b> de votre appartement ou les intérêts hypothécaires de votre
              propriété, ainsi que les <b>autres charges et frais liés au logement</b> constituent
              habituellement le groupe de dépense le plus lourd dans le budget
              des ménages.
            </p>
          </div>
          <MoneyLeftOver
            id={2}
            articleId={ARTICLE_ID}
            showGhost={false}
            title={'Logement'}
            income={this.state.income}
            spent={this.state.expenses[1].value}
            default={this.state.income * defaultPcts['Housing']}
            onChange={value => this.calculateSpentAmount(2, value)}
            onValidate={
              () => {
                this.validateSection(2)
              }
            }
          />
        </div>)}

        {this.state.expenses[3].visible && (<div className='section'>
          <div className='scrollama-container'>
            <MoneyCanvas 
              stage={this.state.canvases[1].stage}
              initialSize={1}
              targetSizes={[1 - this.state.expenses[2].value / this.state.income]}
              />
            <div className='steps'>
              <Scrollama debug={false} onStepEnter={(args: SliderProps) => {
                console.log('Stage ' + args.data + ' - ' + args.direction)
                let canvases = this.state.canvases
                canvases[1].stage = args.data
                this.setState({canvases: canvases})
              }}>
                <Step data={1}>
                  <div style={{height: '50vh'}} />
                </Step>
                <Step data={2}>
                  <div style={{height: '25vh'}}>
                    <div className='ui container text message'>
                        <p className='special'>
                          Après ces trois postes de dépense: les impôts, le logement et la santé, votre revenu s’est déjà réduit de{' '}
                          <b>{Math.round(this.state.expenses[2].value / this.state.income * 100)}%</b>.
                        </p>
                    </div>
                  </div>
                </Step>
                <Step data={3}>
                  <div style={{height: '50vh'}} />
                </Step>
              </Scrollama>
            </div>
          </div>
          <div className='ui text container'>
            <p className='special' >
              Parmi les groupes de dépense importants, on trouve bien sûr <b>l’alimentation</b>, qui se place
              généralement en troisième position, proche des dépenses alouées aux transports. Les frais de
              restaurant font aussi partie de ce poste.
            </p>
          </div>
          <MoneyLeftOver
            id={3}
            articleId={ARTICLE_ID}
            showGhost={false}
            title={'Alimentaire'}
            income={this.state.income}
            spent={this.state.expenses[2].value}
            default={this.state.income * defaultPcts['Food']}
            onChange={value => this.calculateSpentAmount(3, value)}
            onValidate={
              () => {
                this.validateSection(3)
              }
            }
          />
        </div>)}

        {this.state.expenses[4].visible && (<div className='section'>
        <div className='ui text container'>
            <p className='special' >
              Les dépenses pour les <b>vêtements et chaussures</b> représentent habituellement une charge moins
              importante, avec près de 2% du revenu brut.
            </p>
          </div>
          <MoneyLeftOver
            id={4}
            articleId={ARTICLE_ID}
            showGhost={false}
            title={'Vêtements et chaussures'}
            income={this.state.income}
            spent={this.state.expenses[3].value}
            default={this.state.income * defaultPcts['Clothing']}
            onChange={value => this.calculateSpentAmount(4, value)}
            onValidate={
              () => {
                this.validateSection(4)
              }
            }
          />
        </div>)}

        {this.state.expenses[5].visible && (<div className='section'>

          <div className='scrollama-container'>
            <MoneyCanvas 
              stage={this.state.canvases[2].stage}
              initialSize={(this.state.income - this.state.expenses[2].value) / this.state.income}
              targetSizes={[(this.state.income - this.state.expenses[4].value) / this.state.income]}
            />
            <div className='steps'>
              <Scrollama debug={false} onStepEnter={(args: SliderProps) => {
                console.log('Stage ' + args.data + ' - ' + args.direction)
                let canvases = this.state.canvases
                canvases[2].stage = args.data
                this.setState({canvases: canvases})
              }}>
                <Step data={1}>
                  <div style={{height: '50vh'}} />
                </Step>
                <Step data={2}>
                  <div style={{height: '25vh'}}>
                    <div className='ui container text message'>
                        <p className='special'>
                          L’alimentation ainsi que les vêtements et chaussures représentent{' '}
                          <b>{Math.round((this.state.expenses[3].spent + this.state.expenses[4].spent) / this.state.income * 100)}%</b> de vos dépenses mensuelles.
                        </p>
                    </div>
                  </div>
                </Step>
                <Step data={3}>
                  <div style={{height: '50vh'}} />
                </Step>
              </Scrollama>
            </div>
          </div>

          <div className='ui text container'>
            <p className='special' >
              Le budget aloué chaque mois aux <b>transports</b> concerne aussi bien
              les frais d’essence et d’entretien de votre véhicule que les billets et
              abonnements de transports publics.
            </p>
          </div>
          <MoneyLeftOver
            id={5}
            articleId={ARTICLE_ID}
            showGhost={false}
            title={'Transports'}
            income={this.state.income}
            spent={this.state.expenses[4].value}
            default={this.state.income * defaultPcts['Transports']}
            onChange={value => this.calculateSpentAmount(5, value)}
            onValidate={
              () => {
                this.validateSection(5)
              }
            }
          />
        </div>)}

        {this.state.expenses[6].visible && (<div className='section'>
          <div className='ui text container'>
            <p className='special' >
              Les <b>communications</b> forment un poste de dépense relativement faible qui regroupe
              les frais de téléphone (ligne fixe et téléphone portable), d’internet et de télévision.
            </p>
          </div>
          <MoneyLeftOver
            id={6}
            articleId={ARTICLE_ID}
            showGhost={false}
            title={'Communications'}
            income={this.state.income}
            spent={this.state.expenses[5].value}
            default={this.state.income * defaultPcts['Communications']}
            onChange={value => this.calculateSpentAmount(6, value)}
            onValidate={
              () => {
                this.validateSection(6)
              }
            }
          />
        </div>)}

        {this.state.expenses[7].visible && (<div className='section'>
          <div className='scrollama-container'>
            <MoneyCanvas 
              stage={this.state.canvases[3].stage}
              initialSize={0.25}
              targetSizes={[(this.state.income - this.state.expenses[6].value) / this.state.income]}
            />
            <div className='steps'>
              <Scrollama debug={false} onStepEnter={(args: SliderProps) => {
                console.log('Stage ' + args.data + ' - ' + args.direction)
                let canvases = this.state.canvases
                canvases[3].stage = args.data
                this.setState({canvases: canvases})
              }}>
                <Step data={1}>
                  <div style={{height: '50vh'}} />
                </Step>
                <Step data={2}>
                  <div style={{height: '25vh'}}>
                    <div className='ui container text message'>
                        <p className='special'>
                          Les dépenses dédiées aux transports et aux communications représentent{' '}
                          <b>{Math.round((this.state.expenses[5].spent + this.state.expenses[6].spent) / this.state.income * 100)}%</b>{' '}
                          de votre revenu.
                        </p>
                    </div>
                  </div>
                </Step>
                <Step data={3}>
                  <div style={{height: '50vh'}} />
                </Step>
              </Scrollama>
            </div>
          </div>

          <div className='ui text container'>
            <p className='special' >
              Les dépenses pour les <b>loisirs et la culture</b> représentent un autre poste
              relativement important. On y trouve par exemple la redevance pour la radio et la
              télévision, les théâtres, concerts, cinéma et musées. Les services
              sportifs et récréatifs et les dépenses pour les animaux domestiques en font
              également partie.
            </p>
          </div>
          <MoneyLeftOver
            id={7}
            articleId={ARTICLE_ID}
            showGhost={false}
            title={'Loisirs et culture'}
            income={this.state.income}
            spent={this.state.expenses[6].value}
            default={this.state.income * defaultPcts['Hobbies']}
            onChange={value => this.calculateSpentAmount(7, value)}
            onValidate={
              () => {
                this.validateSection(7)
              }
            }
          />
        </div>)}

        {this.state.expenses[8].visible && (<div className='section'>
          <div className='ui text container'>
            <p className='special' >
              Finalement, estimez <b>tous les autres frais</b> qui n’ont pas été pris en compte
              jusqu’ici. Ceux-ci peuvent inclure les dons, cadeaux, certaines taxes ou primes
              d’assurance, les transferts d’argent vers d’autres ménages, etc.
            </p>
          </div>
          <MoneyLeftOver
            id={8}
            articleId={ARTICLE_ID}
            showGhost={false}
            title={'Autres frais'}
            income={this.state.income}
            spent={this.state.expenses[7].value}
            default={this.state.income * defaultPcts['Others']}
            onChange={value => this.calculateSpentAmount(8, value)}
            onValidate={
              () => {
                this.validateSection(8)
              }
            }
          />

          <div className='scrollama-container' style={{height:'300vh'}}>
            <MoneyCanvas 
              stage={this.state.canvases[4].stage}
              initialSize={1}
              targetSizes={[
                (this.state.income - this.state.expenses[8].value) / this.state.income,
                0.25,
                0
              ]}
            />
            <div className='steps'>
              <Scrollama debug={false} onStepEnter={(args: SliderProps) => {
                console.log('Stage ' + args.data + ' - ' + args.direction)
                let canvases = this.state.canvases
                canvases[4].stage = args.data
                this.setState({canvases: canvases})
              }}>
                <Step data={1}>
                  <div style={{height: '50vh'}} />
                </Step>
                <Step data={2}>
                  <div style={{height: '25vh'}}>
                    <div className='ui container text message'>
                        <p className='special'>Selon vos estimations, il ne vous reste plus que{' '}
                        <b>{this.state.income - this.state.expenses[8].value} fr.</b>
                        {' '}à la fin du mois, soit <b>{Math.round((this.state.income - this.state.expenses[8].value) / this.state.income * 100)}%</b> de votre revenu.</p>
                    </div>
                  </div>
                </Step>
                <Step data={3}>
                  <div style={{height: '50vh'}} />
                </Step>
                <Step data={4}>
                  <div style={{height: '25vh'}}>
                    <div className='ui container text message'>
                        <p className='special'>En comparaison, voici la part du revenu qui reste aux 20% les plus riches...</p>
                    </div>
                  </div>
                </Step>
                <Step data={4}>
                  <div style={{height: '50vh'}} />
                </Step>
                <Step data={5}>
                  <div style={{height: '25vh'}}>
                    <div className='ui container text message'>
                        <p className='special'>... et aux 20% les plus pauvres</p>
                    </div>
                  </div>
                </Step>
                <Step data={5}>
                  <div style={{height: '50vh'}} />
                </Step>
              </Scrollama>
            </div>
          </div>
        </div>)}

              <div className='ui vertical segment'>
                <div className='ui text container'>
                  <h4>Méthode</h4>
                <p>L'Office fédéral de la statistique (OFS) demande chaque année à plusieurs centaines de ménages tirés au sort d’inscrire, durant un mois, toutes leurs dépenses et revenus dans des documents de relevés. Ils sont assistés en cela par un spécialiste expérimenté. <a href="https://www.bfs.admin.ch/bfs/fr/home/statistiques/situation-economique-sociale-population/enquetes/ebm.html">Enquête sur le budget des ménages <i className='ui external link icon' /></a></p>

<p>La taille de l'échantillon annuel de l'enquête sur le budget des ménages se montait à 3269 en 2016. Plusieurs années consécutives sont toutefois cumulées afin d'améliorer la qualité des résultats. Nous avons ainsi utilisé les derniers chiffres disponibles, ceux cumulés des années 2012 à 2014.</p>

<p>Nous avons compilé les chiffres de chacun des groupes démographiques disponibles sur le site de l'OFS puis nous avons regroupé certaines catégories de dépense afin d’en obtenir neuf groupes distincts.</p>

                </div>
              </div>

          <Footer
          credits={[['Conception et réalisation', 'Mathieu Rudaz']]}
                          starColor={'purple'}
                          hidePortfolioTeaser
                          mailTo={'interactif.tamedia.ch'}
                          locale={'fr'}
                          title={'Comment jugez-vous ce contenu?'}
                          questions={[
                            'La mise en oeuvre a-t-elle fonctionné?', 
                            'Comment jugez-vous la qualité de ce contenu?',
                            'Avez-vous aimé la mise en scène du sujet?']}
          />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
